import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import '../../index.scss';
import {
  getCellContents,
  getCellLabel,
  priorityCells,
  shouldShowCell,
} from '../../TableCellGenerator';

const BookingsTableRow = ({
  booking,
  venue,
  onClick,
  showBookingDetailsModal,
  hideBookingDetailsModal,
}) => {
  return (
    <TableRow hover className="hover" onClick={onClick}>
      {priorityCells.map(cell => {
        const rowClass = booking.pending
          ? 'booking__row__pending'
          : booking.refunded > 0
          ? 'booking__row__refunded'
          : '';

        return shouldShowCell(cell, venue) ? (
          <TableCell
            data-label={getCellLabel(cell.className)}
            key={`${booking.id}${cell.className}`}
            className={`${cell.className} ${rowClass}`}
            style={
              cell.className === 'order__cell'
                ? {
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }
                : null
            }
          >
            {getCellContents(
              cell.className,
              booking,
              venue.currency,
              showBookingDetailsModal
            )}
          </TableCell>
        ) : null;
      })}
    </TableRow>
  );
};

BookingsTableRow.propTypes = {
  venue: PropTypes.object.isRequired,
  booking: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  showBookingDetailsModal: PropTypes.func.isRequired,
};

export default BookingsTableRow;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/BookingsTable/BookingsTableRow/index.jsx